import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import { Button } from '$components'
import { LogoIcon, SidebarLeftIcon, XIcon } from '$components'
import { Fragment, ReactNode, useState, useEffect } from 'react'
import { useModalRegistry } from '@luuna/shared'

export type MobileMenuProps = {
  children: (close: () => void) => ReactNode
}

export function MobileMenu({ children }: MobileMenuProps) {
  const [isOpen, setIsOpen] = useState(false)
  const { openModal, closeModal } = useModalRegistry()

  const handleClose = () => setIsOpen(false)

  useEffect(() => {
    if (isOpen) {
      openModal()
      return () => closeModal()
    }
  }, [isOpen, openModal, closeModal])

  return (
    <Fragment>
      <Button
        variant="secondary"
        onClick={() => setIsOpen(true)}
        className="p-stack-tight! hover:bg-bg-subtle rounded-surface transition-colors"
      >
        <SidebarLeftIcon className="size-4" />
      </Button>

      <Transition
        show={isOpen}
        as={Fragment}
      >
        <Dialog
          onClose={handleClose}
          className="relative z-50"
        >
          {/* Backdrop */}
          <TransitionChild
            as={Fragment}
            enter="ease-enter duration-micro"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-exit duration-micro"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className="fixed inset-0 bg-bg-overlay"
              aria-hidden="true"
            />
          </TransitionChild>

          {/* Panel */}
          <TransitionChild
            as={Fragment}
            enter="ease-enter duration-micro"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="ease-exit duration-micro"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <DialogPanel className="fixed top-0 left-0 w-80 h-full bg-surface border-r border-border-strong p-stack-roomy transform transition-transform">
              <div className="flex items-center justify-between pb-stack-roomy w-full">
                <LogoIcon className="h-5.5 w-20" />

                <Button
                  variant="ghost"
                  onClick={handleClose}
                  className="p-stack-tight! hover:bg-bg-subtle rounded-control transition-colors mb-stack-tight"
                >
                  <XIcon className="size-4" />
                </Button>
              </div>

              {children(handleClose)}
            </DialogPanel>
          </TransitionChild>
        </Dialog>
      </Transition>
    </Fragment>
  )
}
